'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _clamp = require('lodash/clamp');
var EVENT_INTERVAL = 150;
var getInitialLedState = function getInitialLedState() {
  return [[false, false, false, false, false], [false, false, false, false, false], [false, false, false, false, false], [false, false, false, false, false], [false, false, false, false, false]];
};
var convertPresetImageToLedState = function convertPresetImageToLedState(preset) {
  var colums = preset.split(':');
  var result = colums.map(function (row) {
    return row.split('').map(function (num) {
      return num !== '0';
    });
  });
  return result;
};
(function () {
  Entry.Microbit2BleLite = new (/*#__PURE__*/function () {
    function Microbit2LiteBle() {
      (0, _classCallCheck2["default"])(this, Microbit2LiteBle);
      (0, _defineProperty2["default"])(this, "getBlocks", function () {
        var _this = this;
        return {
          microbit2blelite_common_title: {
            skeleton: 'basic_text',
            color: EntryStatic.colorSet.common.TRANSPARENT,
            template: '%1',
            fontColor: '#333333',
            params: [{
              type: 'Text',
              text: Lang.template.microbit2blelite_common_title,
              color: '#333333',
              align: 'center'
            }],
            def: {
              type: 'microbit2blelite_common_title'
            },
            "class": 'microbit2bleliteLed',
            isNotFor: ['Microbit2BleLite'],
            events: {}
          },
          microbit2blelite_get_analog: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#ffffff',
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: this.analogPins,
              value: 0,
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            "class": 'microbit2blelitePin',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_get_analog'
            },
            paramsKeyMap: {
              VALUE: 0
            },
            func: function () {
              var _func = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(sprite, script) {
                var value;
                return _regenerator["default"].wrap(function (_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      value = script.getValue('VALUE'); // const pinData = await this.services.IoPinService.readPinData();
                      // const ad = await this.services.IoPinService.getAdConfiguration();
                      // const config = await this.services.IoPinService.getIoConfiguration();
                      // console.log(pinData);
                      // console.log(ad);
                      // console.log(config);
                    case 1:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              function func(_x, _x2) {
                return _func.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_set_analog: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#ffffff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: this.analogPins,
              value: 0,
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Block',
              accept: 'string',
              defaultType: 'number'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            "class": 'microbit2blelitePin',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_set_analog'
            },
            paramsKeyMap: {
              PIN: 0,
              VALUE: 1
            },
            func: function () {
              var _func2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(sprite, script) {
                var pin, value, parsedPayload, response;
                return _regenerator["default"].wrap(function (_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      pin = script.getValue('PIN');
                      value = Math.round(_clamp(script.getNumberValue('VALUE'), 0, 1023));
                      parsedPayload = "".concat(pin, ";").concat(value);
                      _context2.next = 1;
                      return _this.getResponseWithSync("".concat(_this.functionKeys.SET_ANALOG, ";").concat(parsedPayload));
                    case 1:
                      response = _context2.sent;
                      return _context2.abrupt("return", _this.getResponse(response));
                    case 2:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              function func(_x3, _x4) {
                return _func2.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_get_digital: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#ffffff',
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: this.digitalPins,
              value: 8,
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            "class": 'microbit2blelitePin',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_get_digital'
            },
            paramsKeyMap: {
              VALUE: 0
            },
            func: function () {
              var _func3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(sprite, script) {
                var value, response;
                return _regenerator["default"].wrap(function (_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      value = script.getValue('VALUE');
                      _context3.next = 1;
                      return _this.getResponseWithSync("".concat(_this.functionKeys.GET_DIGITAL, ";").concat(value));
                    case 1:
                      response = _context3.sent;
                      return _context3.abrupt("return", _this.getResponse(response));
                    case 2:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
              function func(_x5, _x6) {
                return _func3.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_set_digital: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#ffffff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: this.digitalPins,
              value: 8,
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Dropdown',
              options: [[0, 0], [1, 1]],
              value: 0,
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            "class": 'microbit2blelitePin',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_set_digital'
            },
            paramsKeyMap: {
              PIN: 0,
              VALUE: 1
            },
            func: function () {
              var _func4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(sprite, script) {
                var pin, value, parsedPayload, response;
                return _regenerator["default"].wrap(function (_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      pin = script.getValue('PIN');
                      value = script.getValue('VALUE');
                      parsedPayload = "".concat(pin, ";").concat(value);
                      _context4.next = 1;
                      return _this.getResponseWithSync("".concat(_this.functionKeys.SET_DIGITAL, ";").concat(parsedPayload));
                    case 1:
                      response = _context4.sent;
                      return _context4.abrupt("return", _this.getResponse(response));
                    case 2:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }));
              function func(_x7, _x8) {
                return _func4.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_screen_toggle: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [[Lang.Blocks.on, this.functionKeys.DISPLAY_ON], [Lang.Blocks.off, this.functionKeys.DISPLAY_OFF]],
              value: this.functionKeys.DISPLAY_ON,
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            "class": 'microbit2bleliteLed',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_screen_toggle'
            },
            paramsKeyMap: {
              VALUE: 0
            },
            func: function () {
              var _func5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(sprite, script) {
                var command;
                return _regenerator["default"].wrap(function (_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      command = script.getField('VALUE');
                      if (!(command === _this.functionKeys.DISPLAY_ON)) {
                        _context5.next = 2;
                        break;
                      }
                      _context5.next = 1;
                      return _this.services.LedService.writeMatrixState(_this.ledState);
                    case 1:
                      _context5.next = 3;
                      break;
                    case 2:
                      _context5.next = 3;
                      return _this.services.LedService.writeMatrixState(getInitialLedState());
                    case 3:
                    case "end":
                      return _context5.stop();
                  }
                }, _callee5);
              }));
              function func(_x9, _x0) {
                return _func5.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_set_led: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string',
              defaultType: 'number',
              value: 0
            }, {
              type: 'Block',
              accept: 'string',
              defaultType: 'number',
              value: 0
            }, {
              type: 'Block',
              accept: 'string',
              defaultType: 'number',
              value: 9
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            "class": 'microbit2bleliteLed',
            isNotFor: ['Microbit2BleLite'],
            def: {
              params: [{
                type: 'text',
                params: ['0']
              }, {
                type: 'text',
                params: ['0']
              }, {
                type: 'text',
                params: ['9']
              }],
              type: 'microbit2blelite_set_led'
            },
            paramsKeyMap: {
              X: 0,
              Y: 1,
              VALUE: 2
            },
            func: function () {
              var _func6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(sprite, script) {
                var value, x, y;
                return _regenerator["default"].wrap(function (_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      value = script.getNumberValue('VALUE');
                      x = script.getNumberValue('X');
                      y = script.getNumberValue('Y');
                      if (!(x < 0 || y < 0 || x > 4 || y > 4 || value < 0 || value > 9)) {
                        _context6.next = 1;
                        break;
                      }
                      return _context6.abrupt("return");
                    case 1:
                      _this.ledState[y][x] = value !== 0;
                      _context6.next = 2;
                      return _this.services.LedService.writeMatrixState(_this.ledState);
                    case 2:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              }));
              function func(_x1, _x10) {
                return _func6.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_get_led: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#ffffff',
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string',
              defaultType: 'number',
              value: 0
            }, {
              type: 'Block',
              accept: 'string',
              defaultType: 'number',
              value: 0
            }],
            events: {},
            "class": 'microbit2bleliteLed',
            isNotFor: ['Microbit2BleLite'],
            def: {
              params: [{
                type: 'text',
                params: ['0']
              }, {
                type: 'text',
                params: ['0']
              }],
              type: 'microbit2blelite_get_led'
            },
            paramsKeyMap: {
              X: 0,
              Y: 1
            },
            func: function () {
              var _func7 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(sprite, script) {
                var x, y, deviceLedState, targetLed;
                return _regenerator["default"].wrap(function (_context7) {
                  while (1) switch (_context7.prev = _context7.next) {
                    case 0:
                      x = script.getNumberValue('X');
                      y = script.getNumberValue('Y');
                      if (!(x < 0 || y < 0 || x > 4 || y > 4)) {
                        _context7.next = 1;
                        break;
                      }
                      return _context7.abrupt("return", -1);
                    case 1:
                      _context7.next = 2;
                      return _this.services.LedService.readMatrixState();
                    case 2:
                      deviceLedState = _context7.sent;
                      targetLed = deviceLedState[y][x] ? 1 : 0;
                      return _context7.abrupt("return", targetLed);
                    case 3:
                    case "end":
                      return _context7.stop();
                  }
                }, _callee7);
              }));
              function func(_x11, _x12) {
                return _func7.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_show_preset_image: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#ffffff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [[Lang.Blocks.microbit_2_HEART, 0], [Lang.Blocks.microbit_2_HEART_SMALL, 1], [Lang.Blocks.microbit_2_HAPPY, 2], [Lang.Blocks.microbit_2_SMILE, 3], [Lang.Blocks.microbit_2_SAD, 4], [Lang.Blocks.microbit_2_CONFUSED, 5], [Lang.Blocks.microbit_2_ANGRY, 6], [Lang.Blocks.microbit_2_ASLEEP, 7], [Lang.Blocks.microbit_2_SURPRISED, 8], [Lang.Blocks.microbit_2_SILLY, 9], [Lang.Blocks.microbit_2_FABULOUS, 10], [Lang.Blocks.microbit_2_MEH, 11], [Lang.Blocks.microbit_2_YES, 12], [Lang.Blocks.microbit_2_NO, 13], [Lang.Blocks.microbit_2_TRIANGLE, 34], [Lang.Blocks.microbit_2_TRIANGLE_LEFT, 35], [Lang.Blocks.microbit_2_CHESSBOARD, 36], [Lang.Blocks.microbit_2_DIAMOND, 37], [Lang.Blocks.microbit_2_DIAMOND_SMALL, 38], [Lang.Blocks.microbit_2_SQUARE, 39], [Lang.Blocks.microbit_2_SQUARE_SMALL, 40], [Lang.Blocks.microbit_2_RABBIT, 41], [Lang.Blocks.microbit_2_COW, 42], [Lang.Blocks.microbit_2_MUSIC_CROTCHET, 43], [Lang.Blocks.microbit_2_MUSIC_QUAVER, 44], [Lang.Blocks.microbit_2_MUSIC_QUAVERS, 45], [Lang.Blocks.microbit_2_PITCHFORK, 46], [Lang.Blocks.microbit_2_XMAS, 47], [Lang.Blocks.microbit_2_PACMAN, 48], [Lang.Blocks.microbit_2_TARGET, 49], [Lang.Blocks.microbit_2_TSHIRT, 50], [Lang.Blocks.microbit_2_ROLLERSKATE, 51], [Lang.Blocks.microbit_2_DUCK, 52], [Lang.Blocks.microbit_2_HOUSE, 53], [Lang.Blocks.microbit_2_TORTOISE, 54], [Lang.Blocks.microbit_2_BUTTERFLY, 55], [Lang.Blocks.microbit_2_STICKFIGURE, 56], [Lang.Blocks.microbit_2_GHOST, 57], [Lang.Blocks.microbit_2_SWORD, 58], [Lang.Blocks.microbit_2_GIRAFFE, 59], [Lang.Blocks.microbit_2_SKULL, 60], [Lang.Blocks.microbit_2_UMBRELLA, 61], [Lang.Blocks.microbit_2_SNAKE, 62], [Lang.Blocks.microbit_2_CLOCK1, 14], [Lang.Blocks.microbit_2_CLOCK2, 15], [Lang.Blocks.microbit_2_CLOCK3, 16], [Lang.Blocks.microbit_2_CLOCK4, 17], [Lang.Blocks.microbit_2_CLOCK5, 18], [Lang.Blocks.microbit_2_CLOCK6, 19], [Lang.Blocks.microbit_2_CLOCK7, 20], [Lang.Blocks.microbit_2_CLOCK8, 21], [Lang.Blocks.microbit_2_CLOCK9, 22], [Lang.Blocks.microbit_2_CLOCK10, 23], [Lang.Blocks.microbit_2_CLOCK11, 24], [Lang.Blocks.microbit_2_CLOCK12, 25], [Lang.Blocks.microbit_2_ARROW_N, 26], [Lang.Blocks.microbit_2_ARROW_NE, 27], [Lang.Blocks.microbit_2_ARROW_E, 28], [Lang.Blocks.microbit_2_ARROW_SE, 29], [Lang.Blocks.microbit_2_ARROW_S, 30], [Lang.Blocks.microbit_2_ARROW_SW, 31], [Lang.Blocks.microbit_2_ARROW_W, 32], [Lang.Blocks.microbit_2_ARROW_NW, 33]],
              value: 0,
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            "class": 'microbit2bleliteLed',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_show_preset_image'
            },
            paramsKeyMap: {
              VALUE: 0
            },
            func: function () {
              var _func8 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(sprite, script) {
                var value, presetImage;
                return _regenerator["default"].wrap(function (_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      value = _clamp(script.getNumberValue('VALUE'), 0, 62);
                      presetImage = _this.presetImage[value];
                      _this.ledState = convertPresetImageToLedState(presetImage);
                      _context8.next = 1;
                      return _this.services.LedService.writeMatrixState(_this.ledState);
                    case 1:
                    case "end":
                      return _context8.stop();
                  }
                }, _callee8);
              }));
              function func(_x13, _x14) {
                return _func8.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_show_custom_image: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Led2'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            "class": 'microbit2bleliteLed',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_show_custom_image'
            },
            paramsKeyMap: {
              VALUE: 0
            },
            func: function () {
              var _func9 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9(sprite, script) {
                var value, processedValue, i, parsedPayload;
                return _regenerator["default"].wrap(function (_context9) {
                  while (1) switch (_context9.prev = _context9.next) {
                    case 0:
                      value = script.getField('VALUE');
                      processedValue = [];
                      for (i in value) {
                        processedValue[i] = value[i].join();
                      }
                      parsedPayload = "".concat(processedValue.join(':').replace(/,/gi, ''));
                      _this.ledState = convertPresetImageToLedState(parsedPayload);
                      _context9.next = 1;
                      return _this.services.LedService.writeMatrixState(_this.ledState);
                    case 1:
                    case "end":
                      return _context9.stop();
                  }
                }, _callee9);
              }));
              function func(_x15, _x16) {
                return _func9.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_show_string: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            "class": 'microbit2bleliteLed',
            isNotFor: ['Microbit2BleLite'],
            def: {
              params: [{
                type: 'text',
                params: ['Hello!'],
                accept: 'string'
              }],
              type: 'microbit2blelite_show_string'
            },
            paramsKeyMap: {
              VALUE: 0
            },
            func: function () {
              var _func0 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee0(sprite, script) {
                var payload, text;
                return _regenerator["default"].wrap(function (_context0) {
                  while (1) switch (_context0.prev = _context0.next) {
                    case 0:
                      payload = script.getStringValue('VALUE');
                      text = payload.replace(/[^A-Za-z0-9_\`\~\!\@\#\$\%\^\&\*\(\)\-\=\+\\\{\}\[\]\'\"\;\:\<\,\>\.\?\/\s]/gim, '');
                      _context0.next = 1;
                      return _this.services.LedService.writeText(text);
                    case 1:
                    case "end":
                      return _context0.stop();
                  }
                }, _callee0);
              }));
              function func(_x17, _x18) {
                return _func0.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_reset_screen: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [[Lang.Blocks.remove, 'remove'], [Lang.Blocks.light, 'light']],
              value: 'remove',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            "class": 'microbit2bleliteLed',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_reset_screen'
            },
            paramsKeyMap: {
              LED_STATUS: 0
            },
            func: function () {
              var _func1 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee1(sprite, script) {
                var ledStatus, defaultLed;
                return _regenerator["default"].wrap(function (_context1) {
                  while (1) switch (_context1.prev = _context1.next) {
                    case 0:
                      ledStatus = script.getField('LED_STATUS');
                      if (ledStatus === 'light') {
                        defaultLed = '99999:99999:99999:99999:99999';
                        _this.ledState = convertPresetImageToLedState(defaultLed);
                      } else {
                        _this.ledState = getInitialLedState();
                      }
                      _context1.next = 1;
                      return _this.services.LedService.writeMatrixState(_this.ledState);
                    case 1:
                    case "end":
                      return _context1.stop();
                  }
                }, _callee1);
              }));
              function func(_x19, _x20) {
                return _func1.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_radio_toggle: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [[Lang.Blocks.on, this.functionKeys.RADIO_ON], [Lang.Blocks.off, this.functionKeys.RADIO_OFF]],
              value: this.functionKeys.RADIO_ON,
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            "class": 'microbit2bleliteRadio',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_radio_toggle'
            },
            paramsKeyMap: {
              VALUE: 0
            },
            func: function () {
              var _func10 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee10(sprite, script) {
                var command, response;
                return _regenerator["default"].wrap(function (_context10) {
                  while (1) switch (_context10.prev = _context10.next) {
                    case 0:
                      command = script.getField('VALUE');
                      _context10.next = 1;
                      return _this.getResponseWithSync("".concat(command, ";"));
                    case 1:
                      response = _context10.sent;
                      return _context10.abrupt("return", _this.getResponse(response));
                    case 2:
                    case "end":
                      return _context10.stop();
                  }
                }, _callee10);
              }));
              function func(_x21, _x22) {
                return _func10.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_radio_setting: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string',
              defaultType: 'number',
              value: 7
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            "class": 'microbit2bleliteRadio',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_radio_setting'
            },
            paramsKeyMap: {
              RATE: 0,
              CHANNEL: 1
            },
            func: function () {
              var _func11 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee11(sprite, script) {
                var channel, response;
                return _regenerator["default"].wrap(function (_context11) {
                  while (1) switch (_context11.prev = _context11.next) {
                    case 0:
                      if (Entry.Utils.isNumber(script.getNumberValue('CHANNEL'))) {
                        _context11.next = 1;
                        break;
                      }
                      return _context11.abrupt("return");
                    case 1:
                      channel = Math.round(_clamp(script.getNumberValue('CHANNEL'), 0, 83));
                      _context11.next = 2;
                      return _this.getResponseWithSync("".concat(_this.functionKeys.SETTING_RADIO, ";").concat(channel));
                    case 2:
                      response = _context11.sent;
                      return _context11.abrupt("return", _this.getResponse(response));
                    case 3:
                    case "end":
                      return _context11.stop();
                  }
                }, _callee11);
              }));
              function func(_x23, _x24) {
                return _func11.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_radio_send: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            "class": 'microbit2bleliteRadio',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_radio_send'
            },
            paramsKeyMap: {
              VALUE: 0
            },
            func: function () {
              var _func12 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee12(sprite, script) {
                var value, response;
                return _regenerator["default"].wrap(function (_context12) {
                  while (1) switch (_context12.prev = _context12.next) {
                    case 0:
                      value = script.getStringValue('VALUE');
                      _context12.next = 1;
                      return _this.getResponseWithSync("".concat(_this.functionKeys.SET_RADIO, ";").concat(value));
                    case 1:
                      response = _context12.sent;
                      return _context12.abrupt("return", _this.getResponse(response));
                    case 2:
                    case "end":
                      return _context12.stop();
                  }
                }, _callee12);
              }));
              function func(_x25, _x26) {
                return _func12.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_radio_received: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#ffffff',
            skeleton: 'basic_string_field',
            statements: [],
            params: [],
            events: {},
            "class": 'microbit2bleliteRadio',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_radio_received'
            },
            paramsKeyMap: {},
            func: function () {
              var _func13 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee13(sprite, script) {
                var response;
                return _regenerator["default"].wrap(function (_context13) {
                  while (1) switch (_context13.prev = _context13.next) {
                    case 0:
                      _context13.next = 1;
                      return _this.getResponseWithSync("".concat(_this.functionKeys.GET_RADIO, ";"));
                    case 1:
                      response = _context13.sent;
                      return _context13.abrupt("return", _this.getResponse(response));
                    case 2:
                    case "end":
                      return _context13.stop();
                  }
                }, _callee13);
              }));
              function func(_x27, _x28) {
                return _func13.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_change_tempo: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string',
              defaultType: 'number'
            }, {
              type: 'Block',
              accept: 'string',
              defaultType: 'number'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            "class": 'microbit2bleliteSound',
            isNotFor: ['Microbit2BleLite'],
            def: {
              params: [{
                type: 'text',
                params: ['4']
              }, {
                type: 'text',
                params: ['120']
              }],
              type: 'microbit2blelite_change_tempo'
            },
            paramsKeyMap: {
              BEAT: 0,
              BPM: 1
            },
            func: function () {
              var _func14 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee14(sprite, script) {
                var beat, bpm, parsedPayload, response;
                return _regenerator["default"].wrap(function (_context14) {
                  while (1) switch (_context14.prev = _context14.next) {
                    case 0:
                      beat = Math.round(_clamp(script.getNumberValue('BEAT'), 0, 4));
                      bpm = Math.round(_clamp(script.getNumberValue('BPM'), 1, 230));
                      parsedPayload = "".concat(beat, ";").concat(bpm);
                      _context14.next = 1;
                      return _this.getResponseWithSync("".concat(_this.functionKeys.CHANGE_TEMPO, ";").concat(parsedPayload));
                    case 1:
                      response = _context14.sent;
                      return _context14.abrupt("return", _this.getResponse(response));
                    case 2:
                    case "end":
                      return _context14.stop();
                  }
                }, _callee14);
              }));
              function func(_x29, _x30) {
                return _func14.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_set_tone: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'MusicScale'
            }, {
              type: 'Dropdown',
              options: [['4', 16], ['2', 8], ['1', 4], ['1/2', 2], ['1/4', 1]],
              value: 4,
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            "class": 'microbit2bleliteSound',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_set_tone'
            },
            paramsKeyMap: {
              SCALE: 0,
              NOTE: 1
            },
            func: function () {
              var _func15 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee15(sprite, script) {
                var scale, note, parsedPayload, response;
                return _regenerator["default"].wrap(function (_context15) {
                  while (1) switch (_context15.prev = _context15.next) {
                    case 0:
                      scale = script.getField('SCALE');
                      note = script.getField('NOTE');
                      parsedPayload = "".concat(scale, ":").concat(note);
                      _context15.next = 1;
                      return _this.getResponseWithSync("".concat(_this.functionKeys.PLAY_TONE, ";").concat(parsedPayload));
                    case 1:
                      response = _context15.sent;
                      return _context15.abrupt("return", _this.getResponse(response));
                    case 2:
                    case "end":
                      return _context15.stop();
                  }
                }, _callee15);
              }));
              function func(_x31, _x32) {
                return _func15.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_play_preset_music: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#ffffff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [[Lang.Blocks.DADADADUM, 0], [Lang.Blocks.ENTERTAINER, 1], [Lang.Blocks.PRELUDE, 2], [Lang.Blocks.ODE, 3], [Lang.Blocks.NYAN, 4], [Lang.Blocks.RINGTONE, 5], [Lang.Blocks.FUNK, 6], [Lang.Blocks.BLUES, 7], [Lang.Blocks.BIRTHDAY, 8], [Lang.Blocks.WEDDING, 9], [Lang.Blocks.FUNERAL, 10], [Lang.Blocks.PUNCHLINE, 11], [Lang.Blocks.PYTHON, 12], [Lang.Blocks.BADDY, 13], [Lang.Blocks.CHASE, 14], [Lang.Blocks.BA_DING, 15], [Lang.Blocks.WAWAWAWAA, 16], [Lang.Blocks.JUMP_UP, 17], [Lang.Blocks.JUMP_DOWN, 18], [Lang.Blocks.POWER_UP, 19], [Lang.Blocks.POWER_DOWN, 20]],
              value: 0,
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            "class": 'microbit2bleliteSound',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_play_preset_music'
            },
            paramsKeyMap: {
              VALUE: 0
            },
            func: function () {
              var _func16 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee16(sprite, script) {
                var value, response;
                return _regenerator["default"].wrap(function (_context16) {
                  while (1) switch (_context16.prev = _context16.next) {
                    case 0:
                      value = _clamp(script.getNumberValue('VALUE'), 0, 20);
                      _context16.next = 1;
                      return _this.getResponseWithSync("".concat(_this.functionKeys.PLAY_MELODY, ";").concat(value));
                    case 1:
                      response = _context16.sent;
                      _this.getResponse(response);
                      return _context16.abrupt("return", new Promise(function (resolve, reject) {
                        _this.waitMilliSec(500, resolve);
                      }));
                    case 2:
                    case "end":
                      return _context16.stop();
                  }
                }, _callee16);
              }));
              function func(_x33, _x34) {
                return _func16.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_get_btn: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#ffffff',
            skeleton: 'basic_boolean_field',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [['A', 'a'], ['B', 'b'], ['A+B', 'ab']],
              value: 'a',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            "class": 'microbit2bleliteSensor',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_get_btn'
            },
            paramsKeyMap: {
              VALUE: 0
            },
            func: function () {
              var _func17 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee17(sprite, script) {
                var value;
                return _regenerator["default"].wrap(function (_context17) {
                  while (1) switch (_context17.prev = _context17.next) {
                    case 0:
                      value = script.getField('VALUE');
                      if (!(value === 'ab')) {
                        _context17.next = 1;
                        break;
                      }
                      return _context17.abrupt("return", _this.pressedBothButton() ? 1 : 0);
                    case 1:
                      return _context17.abrupt("return", _this.buttonState[value]);
                    case 2:
                    case "end":
                      return _context17.stop();
                  }
                }, _callee17);
              }));
              function func(_x35, _x36) {
                return _func17.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_btn_event: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_event',
            statements: [],
            params: [{
              type: 'Indicator',
              img: 'block_icon/start_icon_hardwarelite.svg',
              size: 14,
              position: {
                x: 0,
                y: -2
              }
            }, {
              type: 'Dropdown',
              options: [['A', '1'], ['B', '2'], ['A+B', '3']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            def: {
              type: 'microbit2blelite_btn_event'
            },
            paramsKeyMap: {
              VALUE: 1
            },
            "class": 'microbit2blelitev2',
            isNotFor: ['Microbit2BleLite'],
            event: 'microbit2blelite_btn_pressed',
            func: function func(sprite, script) {
              return script.callReturn();
            }
          },
          microbit2blelite_get_acc: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#ffffff',
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [[Lang.Blocks.xAxis, 'x'], [Lang.Blocks.yAxis, 'y'], [Lang.Blocks.zAxis, 'z'], [Lang.Blocks.scalar, 'mag']],
              value: 'x',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            "class": 'microbit2bleliteSensor',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_get_acc'
            },
            paramsKeyMap: {
              AXIS: 0
            },
            func: function () {
              var _func18 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee18(sprite, script) {
                var axis, deviceAccData;
                return _regenerator["default"].wrap(function (_context18) {
                  while (1) switch (_context18.prev = _context18.next) {
                    case 0:
                      axis = script.getField('AXIS'); // eslint-disable-next-line max-len
                      _context18.next = 1;
                      return _this.services.AccelerometerService.readAccelerometerData();
                    case 1:
                      deviceAccData = _context18.sent;
                      if (!(axis === 'mag')) {
                        _context18.next = 2;
                        break;
                      }
                      return _context18.abrupt("return", deviceAccData.x + deviceAccData.y + deviceAccData.z);
                    case 2:
                      return _context18.abrupt("return", deviceAccData[axis]);
                    case 3:
                    case "end":
                      return _context18.stop();
                  }
                }, _callee18);
              }));
              function func(_x37, _x38) {
                return _func18.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_get_gesture: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#ffffff',
            skeleton: 'basic_boolean_field',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [[Lang.Blocks.up, 'up'], [Lang.Blocks.down, 'down'], [Lang.Blocks.left, 'left'], [Lang.Blocks.right, 'right'], [Lang.Blocks.face_up, 'face up'], [Lang.Blocks.face_down, 'face down'], [Lang.Blocks.freefall, 'freefall'], [Lang.Blocks['3g'], '3g'], [Lang.Blocks['6g'], '6g'], [Lang.Blocks['8g'], '8g'], [Lang.Blocks['shake'], 'shake']],
              value: 'up',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            "class": 'microbit2bleliteSensor',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_get_gesture'
            },
            paramsKeyMap: {
              GESTURE: 0
            },
            func: function () {
              var _func19 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee19(sprite, script) {
                var gesture, response, parsedResponse;
                return _regenerator["default"].wrap(function (_context19) {
                  while (1) switch (_context19.prev = _context19.next) {
                    case 0:
                      gesture = script.getField('GESTURE');
                      _context19.next = 1;
                      return _this.getResponseWithSync("".concat(_this.functionKeys.GET_GESTURE, ";"));
                    case 1:
                      response = _context19.sent;
                      parsedResponse = _this.getResponse(response);
                      if (!(gesture === parsedResponse[1])) {
                        _context19.next = 2;
                        break;
                      }
                      return _context19.abrupt("return", true);
                    case 2:
                      return _context19.abrupt("return", false);
                    case 3:
                    case "end":
                      return _context19.stop();
                  }
                }, _callee19);
              }));
              function func(_x39, _x40) {
                return _func19.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_get_direction: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#ffffff',
            skeleton: 'basic_string_field',
            statements: [],
            params: [],
            events: {},
            "class": 'microbit2bleliteSensor',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_get_direction'
            },
            paramsKeyMap: {},
            func: function () {
              var _func20 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee20(sprite, script) {
                var response;
                return _regenerator["default"].wrap(function (_context20) {
                  while (1) switch (_context20.prev = _context20.next) {
                    case 0:
                      _context20.next = 1;
                      return _this.getResponseWithSync("".concat(_this.functionKeys.GET_DIRECTION, ";"));
                    case 1:
                      response = _context20.sent;
                      return _context20.abrupt("return", _this.getResponse(response));
                    case 2:
                    case "end":
                      return _context20.stop();
                  }
                }, _callee20);
              }));
              function func(_x41, _x42) {
                return _func20.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_get_field_strength_axis: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#ffffff',
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [[Lang.Blocks.xAxis, 'x'], [Lang.Blocks.yAxis, 'y'], [Lang.Blocks.zAxis, 'z'], [Lang.Blocks.scalar, 'mag']],
              value: 'x',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            "class": 'microbit2bleliteSensor',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_get_field_strength_axis'
            },
            paramsKeyMap: {
              AXIS: 0
            },
            func: function () {
              var _func21 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee21(sprite, script) {
                var axis, deviceMagnetData;
                return _regenerator["default"].wrap(function (_context21) {
                  while (1) switch (_context21.prev = _context21.next) {
                    case 0:
                      axis = script.getField('AXIS'); // eslint-disable-next-line max-len
                      _context21.next = 1;
                      return _this.services.MagnetometerService.readMagnetometerData();
                    case 1:
                      deviceMagnetData = _context21.sent;
                      if (!(axis === 'mag')) {
                        _context21.next = 2;
                        break;
                      }
                      return _context21.abrupt("return", deviceMagnetData.x + deviceMagnetData.y + deviceMagnetData.z);
                    case 2:
                      return _context21.abrupt("return", deviceMagnetData[axis]);
                    case 3:
                    case "end":
                      return _context21.stop();
                  }
                }, _callee21);
              }));
              function func(_x43, _x44) {
                return _func21.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_get_light_level: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#ffffff',
            skeleton: 'basic_string_field',
            statements: [],
            params: [],
            events: {},
            "class": 'microbit2bleliteSensor',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_get_light_level'
            },
            paramsKeyMap: {},
            func: function () {
              var _func22 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee22(sprite, script) {
                var response;
                return _regenerator["default"].wrap(function (_context22) {
                  while (1) switch (_context22.prev = _context22.next) {
                    case 0:
                      _context22.next = 1;
                      return _this.getResponseWithSync("".concat(_this.functionKeys.GET_LIGHT_LEVEL, ";"));
                    case 1:
                      response = _context22.sent;
                      return _context22.abrupt("return", _this.getResponse(response));
                    case 2:
                    case "end":
                      return _context22.stop();
                  }
                }, _callee22);
              }));
              function func(_x45, _x46) {
                return _func22.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_get_temperature: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#ffffff',
            skeleton: 'basic_string_field',
            statements: [],
            params: [],
            events: {},
            "class": 'microbit2bleliteSensor',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_get_temperature'
            },
            paramsKeyMap: {},
            func: function () {
              var _func23 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee23(sprite, script) {
                var temperature;
                return _regenerator["default"].wrap(function (_context23) {
                  while (1) switch (_context23.prev = _context23.next) {
                    case 0:
                      _context23.next = 1;
                      return _this.services.TemperatureService.readTemperature();
                    case 1:
                      temperature = _context23.sent;
                      return _context23.abrupt("return", temperature);
                    case 2:
                    case "end":
                      return _context23.stop();
                  }
                }, _callee23);
              }));
              function func(_x47, _x48) {
                return _func23.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_set_servo: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#ffffff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: this.majorPins,
              value: 0,
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Block',
              accept: 'string',
              defaultType: 'number'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            "class": 'microbit2bleliteServo',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_set_servo'
            },
            paramsKeyMap: {
              PIN: 0,
              VALUE: 1
            },
            func: function () {
              var _func24 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee24(sprite, script) {
                var pin, value, parsedPayload, response;
                return _regenerator["default"].wrap(function (_context24) {
                  while (1) switch (_context24.prev = _context24.next) {
                    case 0:
                      pin = script.getValue('PIN');
                      value = Math.round(_clamp(script.getNumberValue('VALUE'), 0, 180));
                      parsedPayload = "".concat(pin, ";").concat(value);
                      _context24.next = 1;
                      return _this.getResponseWithSync("".concat(_this.functionKeys.SET_SERVO_ANGLE, ";").concat(parsedPayload));
                    case 1:
                      response = _context24.sent;
                      return _context24.abrupt("return", _this.getResponse(response));
                    case 2:
                    case "end":
                      return _context24.stop();
                  }
                }, _callee24);
              }));
              function func(_x49, _x50) {
                return _func24.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_set_pwm: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#ffffff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: this.analogPins,
              value: 0,
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Block',
              accept: 'string',
              defaultType: 'number'
            }, {
              type: 'Dropdown',
              options: [['ms', 'milli'], ['µs', 'micro']],
              value: 'milli',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            "class": 'microbit2bleliteServo',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_set_pwm'
            },
            paramsKeyMap: {
              PIN: 0,
              VALUE: 1,
              UNIT: 2
            },
            func: function () {
              var _func25 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee25(sprite, script) {
                var pin, unit, value, command, parsedPayload, response;
                return _regenerator["default"].wrap(function (_context25) {
                  while (1) switch (_context25.prev = _context25.next) {
                    case 0:
                      pin = script.getValue('PIN');
                      unit = script.getValue('UNIT');
                      value = Math.round(_clamp(script.getNumberValue('VALUE'), 0, 1023));
                      command = unit === 'milli' ? _this.functionKeys.SET_SERVO_MILLI : _this.functionKeys.SET_SERVO_MICRO;
                      parsedPayload = "".concat(pin, ";").concat(value);
                      _context25.next = 1;
                      return _this.getResponseWithSync("".concat(command, ";").concat(parsedPayload));
                    case 1:
                      response = _context25.sent;
                      return _context25.abrupt("return", _this.getResponse(response));
                    case 2:
                    case "end":
                      return _context25.stop();
                  }
                }, _callee25);
              }));
              function func(_x51, _x52) {
                return _func25.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_v2_title: {
            skeleton: 'basic_text',
            color: EntryStatic.colorSet.common.TRANSPARENT,
            fontColor: '#333333',
            template: '%1',
            params: [{
              type: 'Text',
              text: Lang.template.microbit2blelite_v2_title,
              color: '#333333',
              align: 'center'
            }],
            def: {
              type: 'microbit2blelite_v2_title'
            },
            "class": 'microbit2blelitev2',
            isNotFor: ['Microbit2BleLite'],
            events: {}
          },
          microbit2blelite_get_logo: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#ffffff',
            skeleton: 'basic_boolean_field',
            statements: [],
            params: [],
            events: {},
            "class": 'microbit2blelitev2',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_get_logo'
            },
            paramsKeyMap: {},
            func: function () {
              var _func26 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee26(sprite, script) {
                var response, parsedResponse;
                return _regenerator["default"].wrap(function (_context26) {
                  while (1) switch (_context26.prev = _context26.next) {
                    case 0:
                      if (!(_this.version === '1')) {
                        _context26.next = 1;
                        break;
                      }
                      throw new Entry.Utils.IncompatibleError('IncompatibleError', [Lang.Msgs.microbit2blelite_compatible_error]);
                    case 1:
                      _context26.next = 2;
                      return _this.getResponseWithSync("".concat(_this.functionKeys.GET_LOGO, ";"));
                    case 2:
                      response = _context26.sent;
                      parsedResponse = _this.getResponse(response);
                      if (!(parsedResponse == '1')) {
                        _context26.next = 3;
                        break;
                      }
                      return _context26.abrupt("return", 1);
                    case 3:
                      return _context26.abrupt("return", 0);
                    case 4:
                    case "end":
                      return _context26.stop();
                  }
                }, _callee26);
              }));
              function func(_x53, _x54) {
                return _func26.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_get_sound_level: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#ffffff',
            skeleton: 'basic_string_field',
            statements: [],
            params: [],
            events: {},
            "class": 'microbit2blelitev2',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_get_sound_level'
            },
            paramsKeyMap: {},
            func: function () {
              var _func27 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee27(sprite, script) {
                var response;
                return _regenerator["default"].wrap(function (_context27) {
                  while (1) switch (_context27.prev = _context27.next) {
                    case 0:
                      _context27.next = 1;
                      return _this.getResponseWithSync("".concat(_this.functionKeys.GET_SOUND_LEVEL, ";"));
                    case 1:
                      response = _context27.sent;
                      return _context27.abrupt("return", _this.getResponse(response));
                    case 2:
                    case "end":
                      return _context27.stop();
                  }
                }, _callee27);
              }));
              function func(_x55, _x56) {
                return _func27.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_speaker_toggle: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [[Lang.Blocks.on, this.functionKeys.SPEAKER_ON], [Lang.Blocks.off, this.functionKeys.SPEAKER_OFF]],
              value: this.functionKeys.SPEAKER_ON,
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            "class": 'microbit2blelitev2',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_speaker_toggle'
            },
            paramsKeyMap: {
              VALUE: 0
            },
            func: function () {
              var _func28 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee28(sprite, script) {
                var command, response;
                return _regenerator["default"].wrap(function (_context28) {
                  while (1) switch (_context28.prev = _context28.next) {
                    case 0:
                      if (!(_this.version === '1')) {
                        _context28.next = 1;
                        break;
                      }
                      throw new Entry.Utils.IncompatibleError('IncompatibleError', [Lang.Msgs.microbit2_compatible_error]);
                    case 1:
                      command = script.getField('VALUE');
                      _context28.next = 2;
                      return _this.getResponseWithSync("".concat(command, ";"));
                    case 2:
                      response = _context28.sent;
                      return _context28.abrupt("return", _this.getResponse(response));
                    case 3:
                    case "end":
                      return _context28.stop();
                  }
                }, _callee28);
              }));
              function func(_x57, _x58) {
                return _func28.apply(this, arguments);
              }
              return func;
            }()
          },
          microbit2blelite_play_sound_effect: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#ffffff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Dropdown',
              options: [[Lang.Blocks.GIGGLE, 21], [Lang.Blocks.HAPPY, 22], [Lang.Blocks.HELLO, 23], [Lang.Blocks.MYSTERIOUS, 24], [Lang.Blocks.SAD, 25], [Lang.Blocks.SLIDE, 26], [Lang.Blocks.SOARING, 27], [Lang.Blocks.SPRING, 28], [Lang.Blocks.TWINKLE, 29], [Lang.Blocks.YAWN, 30]],
              value: 21,
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            "class": 'microbit2blelitev2',
            isNotFor: ['Microbit2BleLite'],
            def: {
              type: 'microbit2blelite_play_sound_effect'
            },
            paramsKeyMap: {
              VALUE: 0
            },
            func: function () {
              var _func29 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee29(sprite, script) {
                var value, parsedPayload, response;
                return _regenerator["default"].wrap(function (_context29) {
                  while (1) switch (_context29.prev = _context29.next) {
                    case 0:
                      value = _clamp(script.getNumberValue('VALUE'), 21, 30);
                      parsedPayload = "".concat(value);
                      _context29.next = 1;
                      return _this.getResponseWithSync("".concat(_this.functionKeys.PLAY_SOUND, ";").concat(parsedPayload));
                    case 1:
                      response = _context29.sent;
                      return _context29.abrupt("return", _this.getResponse(response));
                    case 2:
                    case "end":
                      return _context29.stop();
                  }
                }, _callee29);
              }));
              function func(_x59, _x60) {
                return _func29.apply(this, arguments);
              }
              return func;
            }()
          }
        };
      });
      this.webapiType = 'ble';
      this.supportFirmwareFlash = true;
      this.bluetoothInfo = {
        filters: [{
          namePrefix: 'BBC micro:bit'
        }]
      };
      this.presetImage = [
      // Image.HEART
      '09090:99999:99999:09990:00900',
      // Image.HEART_SMALL,
      '00000:09090:09990:00900:00000',
      // Image.HAPPY,
      '00000:09090:00000:90009:09990',
      // Image.SMILE,
      '00000:00000:00000:90009:09990',
      // Image.SAD,
      '00000:09090:00000:09990:90009',
      // Image.CONFUSED,
      '00000:09090:00000:09090:90909',
      // Image.ANGRY,
      '90009:09090:00000:99999:90909',
      // Image.ASLEEP,
      '00000:99099:00000:09990:00000',
      // Image.SURPRISED,
      '09090:00000:00900:09090:00900',
      // Image.SILLY,
      '90009:00000:99999:00909:00999',
      // Image.FABULOUS,
      '99999:99099:00000:09090:09990',
      // Image.MEH,
      '09090:00000:00090:00900:09000',
      // Image.YES,
      '00000:00009:00090:90900:09000',
      // Image.NO,
      '90009:09090:00900:09090:90009',
      // Image.CLOCK1,
      '00090:00090:00900:00000:00000',
      // Image.CLOCK2,
      '00000:00990:00900:00000:00000',
      // Image.CLOCK3,
      '00000:00000:00999:00000:00000',
      // Image.CLOCK4,
      '00000:00000:00900:00990:00000',
      // Image.CLOCK5,
      '00000:00000:00900:00090:00090',
      // Image.CLOCK6,
      '00000:00000:00900:00900:00900',
      // Image.CLOCK7,
      '00000:00000:00900:09000:09000',
      // Image.CLOCK8,
      '00000:00000:00900:99000:00000',
      // Image.CLOCK9,
      '00000:00000:99900:00000:00000',
      // Image.CLOCK10,
      '00000:09900:00900:00000:00000',
      // Image.CLOCK11,
      '09000:09000:00900:00000:00000',
      // Image.CLOCK12,
      '00900:00900:00900:00000:00000',
      // Image.ARROW_N,
      '00900:09990:90909:00900:00900',
      // Image.ARROW_NE,
      '00999:00099:00909:09000:90000',
      // Image.ARROW_E,
      '00900:00090:99999:00090:00900',
      // Image.ARROW_SE,
      '90000:09000:00909:00099:00999',
      // Image.ARROW_S,
      '00900:00900:90909:09990:00900',
      // Image.ARROW_SW,
      '00009:00090:90900:99000:99900',
      // Image.ARROW_W,
      '00900:09000:99999:09000:00900',
      // Image.ARROW_NW,
      '99900:99000:90900:00090:00009',
      // Image.TRIANGLE,
      '00000:00900:09090:99999:00000',
      // Image.TRIANGLE_LEFT,
      '90000:99000:90900:90090:99999',
      // Image.CHESSBOARD,
      '09090:90909:09090:90909:09090',
      // Image.DIAMOND,
      '00900:09090:90009:09090:00900',
      // Image.DIAMOND_SMALL,
      '00000:00900:09090:00900:00000',
      // Image.SQUARE,
      '99999:90009:90009:90009:99999',
      // Image.SQUARE_SMALL,
      '00000:09990:09090:09990:00000',
      // Image.RABBIT,
      '90900:90900:99990:99090:99990',
      // Image.COW,
      '90009:90009:99999:09990:00900',
      // Image.MUSIC_CROTCHET,
      '00900:00900:00900:99900:99900',
      // Image.MUSIC_QUAVER,
      '00900:00990:00909:99900:99900',
      // Image.MUSIC_QUAVERS,
      '09999:09009:09009:99099:99099',
      // Image.PITCHFORK,
      '90909:90909:99999:00900:00900',
      // Image.XMAS,
      '00900:09990:00900:09990:99999',
      // Image.PACMAN,
      '099999:99090:99900:99990:09999',
      // Image.TARGET,
      '00900:09990:99099:09990:00900',
      // Image.TSHIRT,
      '99099:99999:09990:09990:09990',
      // Image.ROLLERSKATE,
      '00099:00099:99999:99999:09090',
      // Image.DUCK,
      '00990:99900:09999:09990:00000',
      // Image.HOUSE,
      '00900:09990:99999:09990:09090',
      // Image.TORTOISE,
      '00000:09990:99999:09090:00000',
      // Image.BUTTERFLY,
      '99099:99999:00900:99999:99099',
      // Image.STICKFIGURE,
      '00900:99999:00900:09090:90009',
      // Image.GHOST,
      '99999:90909:99999:99999:90909',
      // Image.SWORD,
      '00900:00900:00900:09990:00900',
      // Image.GIRAFFE,
      '99000:09000:09000:09990:09090',
      // Image.SKULL,
      '09990:90909:99999:09990:09990',
      // Image.UMBRELLA,
      '09990:99999:00900:90900:09900',
      // Image.SNAKE,
      '99000:99099:09090:09990:00000'];
      this.id = '220302';
      this.url = 'http://microbit.org/ko/';
      this.imageName = 'microbit2blelite.png';
      this.title = {
        en: 'Microbit V2',
        ko: '마이크로비트 V2'
      };
      this.name = 'Microbit2BleLite';
      this.functionKeys = {
        LOCALDATA: 'localdata',
        GET_ANALOG: 'get-analog',
        GET_DIGITAL: 'get-digital',
        SET_ANALOG: 'set-analog',
        SET_DIGITAL: 'set-digital',
        SET_LED: 'set-pixel',
        GET_LED: 'get-pixel',
        RESET: 'reset',
        PRESET_IMAGE: 'pre-image',
        SET_CUSTOM_IMAGE: 'custom-image',
        SET_STRING: 'print',
        RESET_SCREEN: 'display-clear',
        DISPLAY_ON: 'display-on',
        DISPLAY_OFF: 'display-off',
        SPEAKER_ON: 'speaker-on',
        SPEAKER_OFF: 'speaker-off',
        PLAY_TONE: 'play-tone',
        PLAY_SOUND: 'pre-sound',
        PLAY_MELODY: 'pre-melody',
        GET_BTN: 'get-btn',
        CHANGE_TEMPO: 'change-tempo',
        GET_LOGO: 'get-touch',
        GET_ACC: 'get-acc',
        GET_GESTURE: 'get-gesture',
        GET_DIRECTION: 'direction',
        GET_FIELD_STRENGTH: 'field-strength',
        GET_FIELD_STRENGTH_AXIS: 'field-axis-strength',
        GET_LIGHT_LEVEL: 'light-level',
        GET_TEMPERATURE: 'temperature',
        GET_SOUND_LEVEL: 'sound-level',
        SET_RADIO: 'radio-send',
        GET_RADIO: 'radio-receive',
        RADIO_ON: 'radio-on',
        RADIO_OFF: 'radio-off',
        SETTING_RADIO: 'radio-setting',
        SET_SERVO_MILLI: 'write-period',
        SET_SERVO_MICRO: 'write-micro-period',
        SET_SERVO_ANGLE: 'servo-write'
      };
      this.presetImage = [
      // Image.HEART
      '09090:99999:99999:09990:00900',
      // Image.HEART_SMALL,
      '00000:09090:09990:00900:00000',
      // Image.HAPPY,
      '00000:09090:00000:90009:09990',
      // Image.SMILE,
      '00000:00000:00000:90009:09990',
      // Image.SAD,
      '00000:09090:00000:09990:90009',
      // Image.CONFUSED,
      '00000:09090:00000:09090:90909',
      // Image.ANGRY,
      '90009:09090:00000:99999:90909',
      // Image.ASLEEP,
      '00000:99099:00000:09990:00000',
      // Image.SURPRISED,
      '09090:00000:00900:09090:00900',
      // Image.SILLY,
      '90009:00000:99999:00909:00999',
      // Image.FABULOUS,
      '99999:99099:00000:09090:09990',
      // Image.MEH,
      '09090:00000:00090:00900:09000',
      // Image.YES,
      '00000:00009:00090:90900:09000',
      // Image.NO,
      '90009:09090:00900:09090:90009',
      // Image.CLOCK1,
      '00090:00090:00900:00000:00000',
      // Image.CLOCK2,
      '00000:00990:00900:00000:00000',
      // Image.CLOCK3,
      '00000:00000:00999:00000:00000',
      // Image.CLOCK4,
      '00000:00000:00900:00990:00000',
      // Image.CLOCK5,
      '00000:00000:00900:00090:00090',
      // Image.CLOCK6,
      '00000:00000:00900:00900:00900',
      // Image.CLOCK7,
      '00000:00000:00900:09000:09000',
      // Image.CLOCK8,
      '00000:00000:00900:99000:00000',
      // Image.CLOCK9,
      '00000:00000:99900:00000:00000',
      // Image.CLOCK10,
      '00000:09900:00900:00000:00000',
      // Image.CLOCK11,
      '09000:09000:00900:00000:00000',
      // Image.CLOCK12,
      '00900:00900:00900:00000:00000',
      // Image.ARROW_N,
      '00900:09990:90909:00900:00900',
      // Image.ARROW_NE,
      '00999:00099:00909:09000:90000',
      // Image.ARROW_E,
      '00900:00090:99999:00090:00900',
      // Image.ARROW_SE,
      '90000:09000:00909:00099:00999',
      // Image.ARROW_S,
      '00900:00900:90909:09990:00900',
      // Image.ARROW_SW,
      '00009:00090:90900:99000:99900',
      // Image.ARROW_W,
      '00900:09000:99999:09000:00900',
      // Image.ARROW_NW,
      '99900:99000:90900:00090:00009',
      // Image.TRIANGLE,
      '00000:00900:09090:99999:00000',
      // Image.TRIANGLE_LEFT,
      '90000:99000:90900:90090:99999',
      // Image.CHESSBOARD,
      '09090:90909:09090:90909:09090',
      // Image.DIAMOND,
      '00900:09090:90009:09090:00900',
      // Image.DIAMOND_SMALL,
      '00000:00900:09090:00900:00000',
      // Image.SQUARE,
      '99999:90009:90009:90009:99999',
      // Image.SQUARE_SMALL,
      '00000:09990:09090:09990:00000',
      // Image.RABBIT,
      '90900:90900:99990:99090:99990',
      // Image.COW,
      '90009:90009:99999:09990:00900',
      // Image.MUSIC_CROTCHET,
      '00900:00900:00900:99900:99900',
      // Image.MUSIC_QUAVER,
      '00900:00990:00909:99900:99900',
      // Image.MUSIC_QUAVERS,
      '09999:09009:09009:99099:99099',
      // Image.PITCHFORK,
      '90909:90909:99999:00900:00900',
      // Image.XMAS,
      '00900:09990:00900:09990:99999',
      // Image.PACMAN,
      '099999:99090:99900:99990:09999',
      // Image.TARGET,
      '00900:09990:99099:09990:00900',
      // Image.TSHIRT,
      '99099:99999:09990:09990:09990',
      // Image.ROLLERSKATE,
      '00099:00099:99999:99999:09090',
      // Image.DUCK,
      '00990:99900:09999:09990:00000',
      // Image.HOUSE,
      '00900:09990:99999:09990:09090',
      // Image.TORTOISE,
      '00000:09990:99999:09090:00000',
      // Image.BUTTERFLY,
      '99099:99999:00900:99999:99099',
      // Image.STICKFIGURE,
      '00900:99999:00900:09090:90009',
      // Image.GHOST,
      '99999:90909:99999:99999:90909',
      // Image.SWORD,
      '00900:00900:00900:09990:00900',
      // Image.GIRAFFE,
      '99000:09000:09000:09990:09090',
      // Image.SKULL,
      '09990:90909:99999:09990:09990',
      // Image.UMBRELLA,
      '09990:99999:00900:90900:09900',
      // Image.SNAKE,
      '99000:99099:09090:09990:00000'];
      this.digitalPins = [['P8', 8], ['P9', 9], ['P12', 12], ['P13', 13], ['P14', 14], ['P15', 15], ['P16', 16]];
      this.analogPins = [['P0', 0], ['P1', 1], ['P2', 2], ['P3', 3], ['P4', 4], ['P10', 10]];
      this.majorPins = [['P0', 0], ['P1', 1], ['P2', 2]];
      this.ledRows = [[0, 0], [1, 1], [2, 2], [3, 3], [4, 4]];
      this.blockMenuBlocks = ['microbit2blelite_common_title',
      // 'microbit2blelite_get_analog',
      // 'microbit2blelite_set_analog',
      // 'microbit2blelite_get_digital',
      // 'microbit2blelite_set_digital',

      'microbit2blelite_screen_toggle', 'microbit2blelite_set_led', 'microbit2blelite_get_led', 'microbit2blelite_show_custom_image', 'microbit2blelite_show_string', 'microbit2blelite_show_preset_image', 'microbit2blelite_reset_screen',
      // 'microbit2blelite_radio_toggle',
      // 'microbit2blelite_radio_setting',
      // 'microbit2blelite_radio_send',
      // 'microbit2blelite_radio_received',

      // 'microbit2blelite_change_tempo',
      // 'microbit2blelite_set_tone',
      // 'microbit2blelite_play_preset_music',

      'microbit2blelite_get_btn', 'microbit2blelite_get_acc',
      // 'microbit2blelite_get_gesture',
      // 'microbit2blelite_get_direction',
      'microbit2blelite_get_field_strength_axis',
      // 'microbit2blelite_get_light_level',
      'microbit2blelite_get_temperature',
      // 'microbit2blelite_set_servo',
      // 'microbit2blelite_set_pwm',

      'microbit2blelite_v2_title',
      // 'microbit2blelite_get_logo',
      'microbit2blelite_btn_event'
      // 'microbit2blelite_speaker_toggle',
      // 'microbit2blelite_play_sound_effect',
      // 'microbit2blelite_get_sound_level',
      ];
      this.services = undefined;
      this.ledState = getInitialLedState();
      this.version = '2';
      this.buttonState = {
        a: 0,
        b: 0
      };
    }
    return (0, _createClass2["default"])(Microbit2LiteBle, [{
      key: "setZero",
      value: function () {
        var _setZero = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee30() {
          return _regenerator["default"].wrap(function (_context30) {
            while (1) switch (_context30.prev = _context30.next) {
              case 0:
                this.ledState = getInitialLedState();
                _context30.next = 1;
                return this.services.LedService.writeMatrixState(this.ledState);
              case 1:
              case "end":
                return _context30.stop();
            }
          }, _callee30, this);
        }));
        function setZero() {
          return _setZero.apply(this, arguments);
        }
        return setZero;
      }()
    }, {
      key: "initialHandshake",
      value: function () {
        var _initialHandshake = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee31() {
          return _regenerator["default"].wrap(function (_context31) {
            while (1) switch (_context31.prev = _context31.next) {
              case 0:
                this.services = Entry.hwLite.bluetooth.services;
                if (!this.services.TemperatureService) {
                  _context31.next = 1;
                  break;
                }
                _context31.next = 1;
                return this.services.TemperatureService.setTemperaturePeriod(2000);
              case 1:
                if (!this.services.AccelerometerService) {
                  _context31.next = 2;
                  break;
                }
                _context31.next = 2;
                return this.services.AccelerometerService.setAccelerometerPeriod(640);
              case 2:
                if (this.services.IoPinService) {
                  // debugger;
                  // console.log(await this.services.IoPinService.getAdConfiguration());
                }
                _context31.next = 3;
                return this.setEventListener();
              case 3:
              case "end":
                return _context31.stop();
            }
          }, _callee31, this);
        }));
        function initialHandshake() {
          return _initialHandshake.apply(this, arguments);
        }
        return initialHandshake;
      }()
    }, {
      key: "setEventListener",
      value: function () {
        var _setEventListener = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee32() {
          return _regenerator["default"].wrap(function (_context32) {
            while (1) switch (_context32.prev = _context32.next) {
              case 0:
                if (this.services) {
                  _context32.next = 1;
                  break;
                }
                return _context32.abrupt("return");
              case 1:
                _context32.next = 2;
                return this.setButtonEvent();
              case 2:
              case "end":
                return _context32.stop();
            }
          }, _callee32, this);
        }));
        function setEventListener() {
          return _setEventListener.apply(this, arguments);
        }
        return setEventListener;
      }()
    }, {
      key: "setPinDataEvent",
      value: function () {
        var _setPinDataEvent = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee33() {
          return _regenerator["default"].wrap(function (_context33) {
            while (1) switch (_context33.prev = _context33.next) {
              case 0:
                if (this.services.IoPinService) {
                  this.services.IoPinService.addEventListener('pindatachanged', function (event) {
                    console.log(event);
                  });
                }
              case 1:
              case "end":
                return _context33.stop();
            }
          }, _callee33, this);
        }));
        function setPinDataEvent() {
          return _setPinDataEvent.apply(this, arguments);
        }
        return setPinDataEvent;
      }()
    }, {
      key: "pressedBothButton",
      value: function pressedBothButton(fireEvent) {
        if (this.buttonState.a + this.buttonState.b === 2) {
          if (fireEvent) {
            Entry.engine.fireEventWithValue('microbit2blelite_btn_pressed', 3);
          }
          return true;
        }
        return false;
      }
    }, {
      key: "setButtonEvent",
      value: function setButtonEvent() {
        var _this2 = this;
        if (this.services.ButtonService) {
          this.services.ButtonService.addEventListener('buttonastatechanged', function (event) {
            _this2.buttonState.a = event.detail;
            if (event.detail === 1 && !_this2.pressedBothButton(true)) {
              Entry.engine.fireEventWithValue('microbit2blelite_btn_pressed', 1);
            }
          });
          this.services.ButtonService.addEventListener('buttonbstatechanged', function (event) {
            _this2.buttonState.b = event.detail;
            if (event.detail === 1 && !_this2.pressedBothButton(true)) {
              Entry.engine.fireEventWithValue('microbit2blelite_btn_pressed', 2);
            }
          });
        }
      }

      // 언어 적용
    }, {
      key: "setLanguage",
      value: function setLanguage() {
        return {
          ko: {
            template: {
              microbit2blelite_get_analog: '핀 %1 번 아날로그 값',
              microbit2blelite_set_analog: '핀 %1 에 아날로그 값 %2 를 출력하기 %3',
              microbit2blelite_get_digital: '핀 %1 번 디지털 값',
              microbit2blelite_set_digital: '핀 %1 에 디지털 값 %2 를 출력하기 %3',
              microbit2blelite_screen_toggle: 'LED 기능 %1 %2',
              microbit2blelite_set_led: 'LED의 X: %1 Y: %2 를 밝기 %3 (으)로 밝히기 %4',
              microbit2blelite_get_led: 'LED의 X: %1 Y: %2 밝기 값',
              microbit2blelite_show_preset_image: 'LED에 %1 모양 나타내기 %2',
              microbit2blelite_show_custom_image: 'LED %1 밝히기 %2',
              microbit2blelite_show_string: 'LED에 %1 을(를) 나타내기 %2',
              microbit2blelite_reset_screen: 'LED 모두 %1 %2',
              microbit2blelite_radio_toggle: '라디오 기능 %1 %2',
              microbit2blelite_radio_setting: '라디오 채널을 %1 (으)로 바꾸기 %2',
              microbit2blelite_radio_send: '라디오로 %1 송신하기 %2',
              microbit2blelite_radio_received: '라디오 수신 값',
              microbit2blelite_speaker_toggle: '스피커 기능 %1 %2',
              microbit2blelite_change_tempo: '연주 속도를 %1 박에 %2 BPM으로 정하기 %3',
              microbit2blelite_set_tone: '%1 음을 %2 박만큼 연주하기 %3',
              microbit2blelite_play_preset_music: '%1 음악을 연주하기 %2',
              microbit2blelite_play_sound_effect: '%1 효과음을 연주하기 %2',
              microbit2blelite_get_btn: '%1 버튼이 눌렸는가?',
              microbit2blelite_get_logo: '로고를 터치했는가?',
              microbit2blelite_get_gesture: '움직임이 %1 인가?',
              microbit2blelite_get_acc: '%1 의 가속도',
              microbit2blelite_btn_event: '%1 %2 버튼을 눌렀을 때',
              microbit2blelite_get_direction: '나침반 방향',
              microbit2blelite_get_field_strength_axis: '%1 의 자기장 세기 값',
              microbit2blelite_get_light_level: '빛 센서 값',
              microbit2blelite_get_temperature: '온도',
              microbit2blelite_get_sound_level: '마이크 소리 크기',
              microbit2blelite_set_servo: '핀 %1 에 서보 모터 각도를 %2 로 정하기 %3',
              microbit2blelite_set_pwm: '핀 %1 에 서보 펄스 폭을 %2 %3초로 정하기 %4',
              microbit2blelite_common_title: '마이크로비트 공통',
              microbit2blelite_v2_title: '마이크로비트 V2 전용'
            },
            Blocks: {
              octave: '옥타브',
              scalar: '스칼라',
              xAxis: 'X축',
              yAxis: 'Y축',
              zAxis: 'Z축',
              up: '위',
              down: '아래',
              left: '왼쪽',
              right: '오른쪽',
              face_up: '앞면',
              face_down: '뒷면',
              freefall: '자유 낙하',
              '3g': '3G',
              '6g': '6G',
              '8g': '8G',
              shake: '흔들림',
              DADADADUM: '운명 교향곡',
              ENTERTAINER: '엔터테이너',
              PRELUDE: '바흐 프렐류드 1번',
              ODE: '합창 교향곡',
              NYAN: '냥캣',
              RINGTONE: '벨소리',
              FUNK: '펑크',
              BLUES: '블루스',
              BIRTHDAY: '생일 축하합니다',
              WEDDING: '결혼 행진곡',
              FUNERAL: '장례식 노래',
              PUNCHLINE: '펀치라인',
              PYTHON: '서커스',
              BADDY: '악당',
              CHASE: '추격전',
              BA_DING: '동전 GET',
              WAWAWAWAA: '실망',
              JUMP_UP: '위로 점프',
              JUMP_DOWN: '아래로 점프',
              POWER_UP: '켜기',
              POWER_DOWN: '끄기',
              GIGGLE: '웃음',
              HAPPY: '행복',
              HELLO: '인사',
              MYSTERIOUS: '신비로움',
              SAD: '슬픔',
              SLIDE: '슬라이드',
              SOARING: '상승',
              SPRING: '봄',
              TWINKLE: '반짝반짝',
              YAWN: '하품',
              plot: '켜기',
              unplot: '끄기',
              on: '켜기',
              off: '끄기',
              remove: '지우기',
              light: '밝히기',
              microbit_2_HEART: '하트',
              microbit_2_HEART_SMALL: '작은 하트',
              microbit_2_HAPPY: '행복',
              microbit_2_SMILE: '웃음',
              microbit_2_SAD: '슬픔',
              microbit_2_CONFUSED: '혼란',
              microbit_2_ANGRY: '화남',
              microbit_2_ASLEEP: '졸림',
              microbit_2_SURPRISED: '놀람',
              microbit_2_SILLY: '메롱',
              microbit_2_FABULOUS: '환상적인',
              microbit_2_MEH: '별로',
              microbit_2_YES: '예스',
              microbit_2_NO: '노',
              microbit_2_TRIANGLE: '삼각형',
              microbit_2_TRIANGLE_LEFT: '왼쪽 삼각형',
              microbit_2_CHESSBOARD: '체스판',
              microbit_2_DIAMOND: '다이아몬드',
              microbit_2_DIAMOND_SMALL: '작은 다이아몬드',
              microbit_2_SQUARE: '사각형',
              microbit_2_SQUARE_SMALL: '작은 사각형',
              microbit_2_RABBIT: '토끼',
              microbit_2_COW: '소',
              microbit_2_MUSIC_CROTCHET: '4분음표',
              microbit_2_MUSIC_QUAVER: '8분음표',
              microbit_2_MUSIC_QUAVERS: '8분음표 2개',
              microbit_2_PITCHFORK: '쇠스랑',
              microbit_2_XMAS: '크리스마스 트리',
              microbit_2_PACMAN: '팩맨',
              microbit_2_TARGET: '표적',
              microbit_2_TSHIRT: '티셔츠',
              microbit_2_ROLLERSKATE: '롤러스케이트',
              microbit_2_DUCK: '오리',
              microbit_2_HOUSE: '집',
              microbit_2_TORTOISE: '거북이',
              microbit_2_BUTTERFLY: '나비',
              microbit_2_STICKFIGURE: '스틱맨',
              microbit_2_GHOST: '유령',
              microbit_2_SWORD: '칼',
              microbit_2_GIRAFFE: '기린',
              microbit_2_SKULL: '해골',
              microbit_2_UMBRELLA: '우산',
              microbit_2_SNAKE: '뱀',
              microbit_2_CLOCK1: '1시',
              microbit_2_CLOCK2: '2시',
              microbit_2_CLOCK3: '3시',
              microbit_2_CLOCK4: '4시',
              microbit_2_CLOCK5: '5시',
              microbit_2_CLOCK6: '6시',
              microbit_2_CLOCK7: '7시',
              microbit_2_CLOCK8: '8시',
              microbit_2_CLOCK9: '9시',
              microbit_2_CLOCK10: '10시',
              microbit_2_CLOCK11: '11시',
              microbit_2_CLOCK12: '12시',
              microbit_2_ARROW_N: '북쪽',
              microbit_2_ARROW_NE: '북동쪽',
              microbit_2_ARROW_E: '동쪽',
              microbit_2_ARROW_SE: '남동쪽',
              microbit_2_ARROW_S: '남쪽',
              microbit_2_ARROW_SW: '남서쪽',
              microbit_2_ARROW_W: '서쪽',
              microbit_2_ARROW_NW: '북서쪽'
            },
            Helper: {
              microbit2blelite_get_analog: '선택한 핀의 아날로그 값입니다. (0 ~ 1023)',
              microbit2blelite_set_analog: '선택한 핀에 입력한 아날로그 값을 출력합니다. (0 ~ 1023)',
              microbit2blelite_get_digital: '선택한 핀의 디지털 값입니다. (0, 1)',
              microbit2blelite_set_digital: '선택한 핀에 입력한 디지털 값을 출력합니다. (0, 1)',
              microbit2blelite_screen_toggle: 'LED 기능을 켜거나 끕니다.',
              microbit2blelite_set_led: 'X, Y 좌표로 선택한 LED를 선택한 밝기로 켭니다.',
              microbit2blelite_get_led: 'X, Y 좌표로 선택한 LED의 밝기 값입니다.',
              microbit2blelite_show_preset_image: 'LED에 미리 설정되어 있는 모양을 나타냅니다.',
              microbit2blelite_show_custom_image: '블록에서 선택한 LED를 선택한 밝기로 밝힙니다. 한 번에 모든 LED를 조작할 수 있습니다.',
              microbit2blelite_show_string: '입력한 문자열을 LED에 차례대로 밝힙니다.',
              microbit2blelite_reset_screen: 'LED를 모두 지우거나 밝힙니다.',
              microbit2blelite_radio_toggle: '라디오 기능을 켜거나 끕니다.',
              microbit2blelite_radio_setting: '라디오 채널을 입력한 숫자로 바꿉니다.',
              microbit2blelite_radio_send: '라디오로 입력한 영문과 숫자를 송신합니다.',
              microbit2blelite_radio_received: '라디오로 수신된 값입니다.',
              microbit2blelite_speaker_toggle: '스피커 기능을 켜거나 끕니다.',
              microbit2blelite_change_tempo: '연주 속도를 선택한 박자와 BPM으로 정합니다.',
              microbit2blelite_set_tone: '선택한 음을 선택한 박만큼 연주합니다. 1~5옥타브 사이의 음계를 선택할 수 있습니다.',
              microbit2blelite_play_preset_music: '미리 설정되어 있는 음악을 연주합니다.',
              microbit2blelite_play_sound_effect: '미리 설정되어 있는 효과음을 연주합니다.',
              microbit2blelite_get_btn: "선택한 버튼이 눌렸다면 '참'으로 판단합니다.",
              microbit2blelite_get_logo: "로고를 터치했다면 '참'으로 판단합니다.",
              microbit2blelite_get_gesture: "선택한 움직임이 감지되면 '참'으로 판단합니다.",
              microbit2blelite_get_acc: '선택한 버튼이 눌리면 아래에 연결된 블록들을 실행합니다.',
              microbit2blelite_btn_event: '%1 %2 버튼을 눌렀을 때',
              microbit2blelite_get_direction: '나침반 방향 값입니다. (0~360) ',
              microbit2blelite_get_field_strength_axis: '선택한 축의 자기장 세기 값입니다.',
              microbit2blelite_get_light_level: '빛 센서의 값입니다.',
              microbit2blelite_get_temperature: '현재 온도 값입니다. (℃)',
              microbit2blelite_get_sound_level: '마이크 소리 크기 값입니다.',
              microbit2blelite_set_servo: '선택한 핀에 서보 모터 각도를 입력한 값으로 정합니다.',
              microbit2blelite_set_pwm: '선택한 핀의 서보 펄스폭을 선택한 시간으로 정합니다.'
            },
            Msgs: {
              microbit2blelite_compatible_error: '마이크로비트 V2에서만 사용할 수 있는 블록입니다.',
              microbit2blelite_octave: '옥타브'
            }
          },
          en: {
            template: {
              microbit2blelite_get_analog: 'analog read pin %1',
              microbit2blelite_set_analog: 'Set analog pin %1 to %2 %3',
              microbit2blelite_get_digital: 'digital read pin %1',
              microbit2blelite_set_digital: 'digital write pin %1 to %2 %3',
              microbit2blelite_screen_toggle: '%1 LED screen %2',
              microbit2blelite_set_led: 'Light X: %1 Y:%2 LED to brightness %3 %4',
              microbit2blelite_get_led: 'brightness of X: %1 Y: %2 LED %3',
              microbit2blelite_show_preset_image: 'Light %1 icon on LED %2',
              microbit2blelite_show_custom_image: 'Light %1 on LED %2',
              microbit2blelite_show_string: 'Light string %1 on LED %2',
              microbit2blelite_reset_screen: '%1 all on LED %2',
              microbit2blelite_radio_toggle: '%1 radio %2',
              microbit2blelite_radio_setting: 'Change radio channel to %1 %2',
              microbit2blelite_radio_send: 'Send %1 to radio %2',
              microbit2blelite_radio_received: 'radio received value',
              microbit2blelite_speaker_toggle: '%1 speaker %2',
              microbit2blelite_change_tempo: 'Set tempo to %2 BPM per %1 beat %3',
              microbit2blelite_set_tone: 'Play melody %1 for %2 beat %3',
              microbit2blelite_play_preset_music: 'Play music %1 %2',
              microbit2blelite_play_sound_effect: 'Play sound %1 %2',
              microbit2blelite_get_btn: '%1 button pressed?',
              microbit2blelite_get_logo: 'logo touched?',
              microbit2blelite_get_gesture: 'Is the movement %1?',
              microbit2blelite_get_acc: 'acceleration value of %1',
              microbit2blelite_btn_event: '%1 When %2 button pressed',
              microbit2blelite_get_direction: 'compass direction',
              microbit2blelite_get_field_strength_axis: 'magnetic field strength value of %1 ',
              microbit2blelite_get_light_level: 'light sensor value',
              microbit2blelite_get_temperature: 'temperature',
              microbit2blelite_get_sound_level: 'microphone volume',
              microbit2blelite_set_servo: 'Set servo pin %1 angle to %2 %3',
              microbit2blelite_set_pwm: 'set servo pin %1 pulse to %2 %3 %4',
              microbit2blelite_common_title: 'Common Blocks',
              microbit2blelite_v2_title: 'v2 Only'
            },
            Blocks: {
              octave: 'octave',
              scalar: 'scalar',
              xAxis: 'X-axis',
              yAxis: 'Y-axis',
              zAxis: 'Z-axis',
              up: 'up',
              down: 'down',
              left: 'left',
              right: 'right',
              face_up: 'face up',
              face_down: 'face down',
              freefall: 'freefall',
              '3g': '3G',
              '6g': '6G',
              '8g': '8G',
              shake: 'shake',
              DADADADUM: 'Dadadadum',
              ENTERTAINER: 'Entertainer',
              PRELUDE: 'Prelude',
              ODE: 'Ode',
              NYAN: 'Nyan',
              RINGTONE: 'Ringtone',
              FUNK: 'Funk',
              BLUES: 'Blues',
              BIRTHDAY: 'Birthday',
              WEDDING: 'Wedding',
              FUNERAL: 'Funeral',
              PUNCHLINE: 'Punchline',
              PYTHON: 'Python',
              BADDY: 'Baddy',
              CHASE: 'Chase',
              BA_DING: 'Coin',
              WAWAWAWAA: 'Wawawawaa',
              JUMP_UP: 'Jump up',
              JUMP_DOWN: 'Jump down',
              POWER_UP: 'Power up',
              POWER_DOWN: 'Power down',
              GIGGLE: 'giggle',
              HAPPY: 'happy',
              HELLO: 'hello',
              MYSTERIOUS: 'mysterious',
              SAD: 'sad',
              SLIDE: 'slide',
              SOARING: 'soaring',
              SPRING: 'spring',
              TWINKLE: 'twinkle',
              YAWN: 'yawn',
              plot: 'plot',
              unplot: 'unplot',
              on: 'Turn on',
              off: 'Turn off',
              remove: 'Clear',
              light: 'Light',
              microbit_2_HEART: 'heart',
              microbit_2_HEART_SMALL: 'small heart',
              microbit_2_HAPPY: 'happy',
              microbit_2_SMILE: 'smile',
              microbit_2_SAD: 'sad',
              microbit_2_CONFUSED: 'confused',
              microbit_2_ANGRY: 'angry',
              microbit_2_ASLEEP: 'asleep',
              microbit_2_SURPRISED: 'surprised',
              microbit_2_SILLY: 'silly',
              microbit_2_FABULOUS: 'fabulous',
              microbit_2_MEH: 'meh',
              microbit_2_YES: 'yes',
              microbit_2_NO: 'no',
              microbit_2_TRIANGLE: 'triangle',
              microbit_2_TRIANGLE_LEFT: 'left triangle',
              microbit_2_CHESSBOARD: 'chessboard',
              microbit_2_DIAMOND: 'diamond',
              microbit_2_DIAMOND_SMALL: 'small diamond',
              microbit_2_SQUARE: 'square',
              microbit_2_SQUARE_SMALL: 'small square',
              microbit_2_RABBIT: 'rabbit',
              microbit_2_COW: 'cow',
              microbit_2_MUSIC_CROTCHET: 'crotchet',
              microbit_2_MUSIC_QUAVER: 'quaver',
              microbit_2_MUSIC_QUAVERS: 'quavers',
              microbit_2_PITCHFORK: 'pitchfork',
              microbit_2_XMAS: 'xmas',
              microbit_2_PACMAN: 'pacman',
              microbit_2_TARGET: 'target',
              microbit_2_TSHIRT: 'tshirt',
              microbit_2_ROLLERSKATE: 'rollerskate',
              microbit_2_DUCK: 'duck',
              microbit_2_HOUSE: 'house',
              microbit_2_TORTOISE: 'tortoise',
              microbit_2_BUTTERFLY: 'butterfly',
              microbit_2_STICKFIGURE: 'stickfigure',
              microbit_2_GHOST: 'ghost',
              microbit_2_SWORD: 'sword',
              microbit_2_GIRAFFE: 'giraffe',
              microbit_2_SKULL: 'skull',
              microbit_2_UMBRELLA: 'umbrella',
              microbit_2_SNAKE: 'snake',
              microbit_2_CLOCK1: "1 o'clock",
              microbit_2_CLOCK2: "2 o'clock",
              microbit_2_CLOCK3: "3 o'clock",
              microbit_2_CLOCK4: "4 o'clock",
              microbit_2_CLOCK5: "5 o'clock",
              microbit_2_CLOCK6: "6 o'clock",
              microbit_2_CLOCK7: "7 o'clock",
              microbit_2_CLOCK8: "8 o'clock",
              microbit_2_CLOCK9: "9 o'clock",
              microbit_2_CLOCK10: "10 o'clock",
              microbit_2_CLOCK11: "11 o'clock",
              microbit_2_CLOCK12: "12 o'clock",
              microbit_2_ARROW_N: 'north',
              microbit_2_ARROW_NE: 'northeast',
              microbit_2_ARROW_E: 'east',
              microbit_2_ARROW_SE: 'southeast',
              microbit_2_ARROW_S: 'south',
              microbit_2_ARROW_SW: 'southwest',
              microbit_2_ARROW_W: 'west',
              microbit_2_ARROW_NW: 'northwest'
            },
            Helper: {
              microbit2blelite_get_analog: 'Reads an analog signal from the pin you choose. (0 ~ 1023)',
              microbit2blelite_set_analog: 'Writes an analog signal to the pin you choose. (0 ~ 1023)',
              microbit2blelite_get_digital: 'Reads a digital signal from the pin you choose. (0 ~ 1023)',
              microbit2blelite_set_digital: 'Writes a digital signal to the pin you choose. (0 ~ 1)',
              microbit2blelite_screen_toggle: 'Turns on or turns off the LED screen.',
              microbit2blelite_set_led: 'Lights the selected LED with X and Y coordinates to the selected brightness.',
              microbit2blelite_get_led: 'Brightness of the selected LED with X and Y coordinates',
              microbit2blelite_show_preset_image: 'Lights the selected icon on the LED screen.',
              microbit2blelite_show_custom_image: 'Lights the selected LED and brightness. You can set all the LEDs at once.',
              microbit2blelite_show_string: 'Lights the entered string in order on the LED screen.',
              microbit2blelite_reset_screen: 'Clears or lights all LED screen.',
              microbit2blelite_radio_toggle: 'Turns on or turns off the radio.',
              microbit2blelite_radio_setting: 'Changes the radio channel to the number entered.',
              microbit2blelite_radio_send: 'Sends the number or the string entered to the radio.',
              microbit2blelite_radio_received: 'Value received by the radio.',
              microbit2blelite_speaker_toggle: 'Turns on or turns off the speaker.',
              microbit2blelite_change_tempo: 'Sets the tempo to the entered beat and BPM.',
              microbit2blelite_set_tone: 'Plays the entered melody for the entered beat. You can choose a scale between 1 and 5 octaves.',
              microbit2blelite_play_preset_music: 'Plays preset music.',
              microbit2blelite_play_sound_effect: 'Plays preset sound.',
              microbit2blelite_get_btn: "If the selected button is pressed, it is judged as 'True'.",
              microbit2blelite_get_logo: "If the logo is touched, it is judged as 'True'.",
              microbit2blelite_get_gesture: "When the selected movement is detected, it is judged as 'True'.",
              microbit2blelite_get_acc: 'The acceleration value of the selected axis.',
              microbit2blelite_btn_event: 'When the selected button is pressed, the connected blocks below will run',
              microbit2blelite_get_direction: 'The compass direction value. (0~360)',
              microbit2blelite_get_field_strength_axis: 'The magnetic field strength value of the selected axis.',
              microbit2blelite_get_light_level: 'The value of the light sensor.',
              microbit2blelite_get_temperature: 'The current temperature value. (℃)',
              microbit2blelite_get_sound_level: 'The microphone volume value.',
              microbit2blelite_set_servo: 'Sets the servo motor angle to the entered value on the selected pin.',
              microbit2blelite_set_pwm: 'Sets the servo pulse to the entered time on the selected pin.'
            },
            Msgs: {
              microbit2blelite_compatible_error: 'The corresponding block is not compatible to Microbit V1',
              microbit2blelite_octave: 'Octave'
            }
          },
          jp: {
            template: {
              microbit2blelite_get_analog: 'ピン %1 のアナログ値',
              microbit2blelite_set_analog: 'ピン %1 にアナログ値 %2 を出力する %3',
              microbit2blelite_get_digital: 'ピン %1 のデジタル値',
              microbit2blelite_set_digital: 'ピン %1 に デジタル値 %2 を出力する %3',
              microbit2blelite_screen_toggle: 'LED機能を %1 %2',
              microbit2blelite_set_led: 'LEDの X: %1 Y: %2 を明るさ %3 にする %4',
              microbit2blelite_get_led: 'LEDの X: %1 Y: %2 の明るさ',
              microbit2blelite_show_preset_image: 'LEDに %1 アイコンを表示する %2',
              microbit2blelite_show_custom_image: 'LED %1 を表示する %2',
              microbit2blelite_show_string: 'LEDに %1 を表示する %2',
              microbit2blelite_reset_screen: 'LEDを全部消す %1',
              microbit2blelite_radio_toggle: 'ラジオ機能を %1 %2',
              microbit2blelite_radio_setting: 'ラジオチャンネルを %1 に変更する %2',
              microbit2blelite_radio_send: 'ラジオに %1 送信する %2',
              microbit2blelite_radio_received: 'ラジオ受信値',
              microbit2blelite_speaker_toggle: 'スピーカー機能 %1 %2',
              microbit2blelite_change_tempo: 'テンポを %1 拍に %2 BPMにする %3',
              microbit2blelite_set_tone: '%1 音を %2 拍演奏する %3',
              microbit2blelite_play_preset_music: '%1 音楽を演奏する %2',
              microbit2blelite_play_sound_effect: '%1 効果音を演奏する %2',
              microbit2blelite_get_btn: '%1 ボタンが押したkか?',
              microbit2blelite_get_logo: 'ロゴをタッチしたじか?',
              microbit2blelite_get_gesture: '動きが %1 なのか?',
              microbit2blelite_get_acc: '%1 の加速度',
              microbit2blelite_get_direction: 'コンパス方向',
              microbit2blelite_get_field_strength_axis: '%1 の磁場強度',
              microbit2blelite_get_light_level: '光センサー値',
              microbit2blelite_get_temperature: '温度値',
              microbit2blelite_get_sound_level: 'マイク音の大きさ',
              microbit2blelite_set_servo: 'ピン %1 に サーボモーターの角度を %2 に設定する %3',
              microbit2blelite_set_pwm: 'ピン %1 にサーボパルス幅を2にする %4',
              microbit2blelite_common_title: 'Common Blocks',
              microbit2blelite_v2_title: 'v2 Only'
            },
            Blocks: {
              octave: 'オクターブ',
              scalar: 'スカラー',
              xAxis: 'X軸',
              yAxis: 'Y軸',
              zAxis: 'Z軸',
              up: '上',
              down: '下',
              left: '右',
              right: '左',
              face_up: '全面',
              face_down: '後面',
              freefall: '自由落下',
              '3g': '3G',
              '6g': '6G',
              '8g': '8G',
              shake: '振れ',
              DADADADUM: '運命交響曲',
              ENTERTAINER: 'エンターネーター',
              PRELUDE: 'バッハ·プレリュード第1番',
              ODE: '合唱交響曲',
              NYAN: 'ニャンキャット',
              RINGTONE: '着信メロディ',
              FUNK: 'ファンク',
              BLUES: 'ブルース',
              BIRTHDAY: 'お誕生日おめでとう',
              WEDDING: '結婚行進曲',
              FUNERAL: '葬式の歌',
              PUNCHLINE: 'パンチライン',
              PYTHON: 'サーカス',
              BADDY: '悪党',
              CHASE: '追撃戦',
              BA_DING: 'コインGET',
              WAWAWAWAA: 'ガッカリ',
              JUMP_UP: '上にジャンプ',
              JUMP_DOWN: '下にジャンプ',
              POWER_UP: '点ける',
              POWER_DOWN: '消す',
              GIGGLE: '笑い',
              HAPPY: '幸せ',
              HELLO: '挨拶',
              MYSTERIOUS: '神秘的',
              SAD: '悲しみ',
              SLIDE: 'スライド',
              SOARING: '上昇',
              SPRING: '春',
              TWINKLE: 'キラキラ',
              YAWN: 'あくび',
              plot: 'オンにする',
              unplot: 'オフにする',
              on: 'オンにする',
              off: 'オフにする',
              microbit_2_HEART: 'ハート',
              microbit_2_HEART_SMALL: '小さなハート',
              microbit_2_HAPPY: '幸せ',
              microbit_2_SMILE: '笑い',
              microbit_2_SAD: '悲しみ',
              microbit_2_CONFUSED: '混乱',
              microbit_2_ANGRY: '怒り',
              microbit_2_ASLEEP: '眠気',
              microbit_2_SURPRISED: '驚き',
              microbit_2_SILLY: '間抜け',
              microbit_2_FABULOUS: '幻想的な',
              microbit_2_MEH: '別に',
              microbit_2_YES: 'イエス',
              microbit_2_NO: 'ノー',
              microbit_2_TRIANGLE: '三角形',
              microbit_2_TRIANGLE_LEFT: '左三角形',
              microbit_2_CHESSBOARD: 'チェスパン',
              microbit_2_DIAMOND: 'ダイヤモンド',
              microbit_2_DIAMOND_SMALL: '小さなダイヤモンド',
              microbit_2_SQUARE: '四角形',
              microbit_2_SQUARE_SMALL: '小さな四角形',
              microbit_2_RABBIT: 'ウサギ',
              microbit_2_COW: '牛',
              microbit_2_MUSIC_CROTCHET: '4分音符',
              microbit_2_MUSIC_QUAVER: '8分音符',
              microbit_2_MUSIC_QUAVERS: '8分音符2個',
              microbit_2_PITCHFORK: 'フォーク',
              microbit_2_XMAS: 'クリスマスツリー',
              microbit_2_PACMAN: 'パックマン',
              microbit_2_TARGET: '標的',
              microbit_2_TSHIRT: 'Tシャツ',
              microbit_2_ROLLERSKATE: 'ローラースケート',
              microbit_2_DUCK: 'アヒル',
              microbit_2_HOUSE: '家',
              microbit_2_TORTOISE: '亀',
              microbit_2_BUTTERFLY: '蝶',
              microbit_2_STICKFIGURE: 'スティックマン',
              microbit_2_GHOST: '幽霊',
              microbit_2_SWORD: 'ナイフ',
              microbit_2_GIRAFFE: 'キリン',
              microbit_2_SKULL: '骸骨',
              microbit_2_UMBRELLA: '傘',
              microbit_2_SNAKE: '蛇',
              microbit_2_CLOCK1: '1時',
              microbit_2_CLOCK2: '2時',
              microbit_2_CLOCK3: '3時',
              microbit_2_CLOCK4: '4時',
              microbit_2_CLOCK5: '5時',
              microbit_2_CLOCK6: '6時',
              microbit_2_CLOCK7: '7時',
              microbit_2_CLOCK8: '8時',
              microbit_2_CLOCK9: '9時',
              microbit_2_CLOCK10: '10時',
              microbit_2_CLOCK11: '11時',
              microbit_2_CLOCK12: '12時',
              microbit_2_ARROW_N: '北',
              microbit_2_ARROW_NE: '北東',
              microbit_2_ARROW_E: '東',
              microbit_2_ARROW_SE: '南東',
              microbit_2_ARROW_S: '南',
              microbit_2_ARROW_SW: '南西',
              microbit_2_ARROW_W: '西',
              microbit_2_ARROW_NW: '北西'
            },
            Helper: {
              microbit2blelite_get_analog: '選択したピンのアナログ値です。(0 ~ 1023)',
              microbit2blelite_set_analog: '選択したピンに入力したアナログ値を出力します。(0 ~ 1023)',
              microbit2blelite_get_digital: '選択したピンのデジタル値です。(0, 1)',
              microbit2blelite_set_digital: '選択したピンに入力したデジタル値を出力します。(0, 1)',
              microbit2blelite_screen_toggle: 'LED機能をオンまたはオフにします。',
              microbit2blelite_set_led: 'X、Y座標で選択したLEDを選択した明るさで点けます。',
              microbit2blelite_get_led: 'X、Y座標で選択したLEDの明るさです。',
              microbit2blelite_show_preset_image: 'LEDに先に設定されていた形で点けます。',
              microbit2blelite_show_custom_image: 'ブロックで選択したLEDを選択した明るさで点けます。 一度にすべてのLEDを操作できます。',
              microbit2blelite_show_string: '入力した文字列をLEDに順番に表示します。',
              microbit2blelite_reset_screen: 'LEDに表示したものをすべて消します。',
              microbit2blelite_radio_toggle: 'ラジオ機能をオンまたはオフにします。',
              microbit2blelite_radio_setting: 'ラジオチャンネルを入力した数字に変えます。',
              microbit2blelite_radio_send: 'ラジオで入力した英数字を送信します。',
              microbit2blelite_radio_received: 'ラジオで受信した値です。',
              microbit2blelite_speaker_toggle: 'スピーカー機能をオンまたはオフにします。',
              microbit2blelite_change_tempo: 'テンポを選択した拍子とBPMで設定します。',
              microbit2blelite_set_tone: '選択した音を選択した拍子で演奏します。 1~5オクターブ間の音階を選べます。',
              microbit2blelite_play_preset_music: '先に設定されていた音楽を演奏します。',
              microbit2blelite_play_sound_effect: '先に設定されていた効果音を演奏します。',
              microbit2blelite_get_btn: '選択したボタンが押されたら、「True」と判断します。',
              microbit2blelite_get_logo: 'ロゴをタッチすると、「True」と判断します。',
              microbit2blelite_get_gesture: '選択した動きを感知したら、「True」と判断します。',
              microbit2blelite_get_acc: '選択した軸の加速度値です。',
              microbit2blelite_get_direction: 'コンパス方向の値です。 (0~360)',
              microbit2blelite_get_field_strength_axis: '選択した軸の磁場強度の値です。',
              microbit2blelite_get_light_level: '光センサーの値です。',
              microbit2blelite_get_temperature: '現在の温度です。 (℃)',
              microbit2blelite_get_sound_level: 'マイクボリュームの値です。',
              microbit2blelite_set_servo: '選択したピンにサーボモーターの角度を入力した値で設定します。',
              microbit2blelite_set_pwm: '選択したピンのサーボパルス幅を選択した値にします。'
            },
            Msgs: {
              microbit2blelite_compatible_error: '対応するブロックはMicrobitV1と互換性がありません',
              microbit2blelite_octave: 'Octave'
            }
          }
        };
      }
    }]);
  }())();
})();
module.exports = Entry.Microbit2BleLite;